import React from "react";
import { Container } from "react-bootstrap";
import SSI_table_holder from "./SSI_table_holder/SSI_table_holder";

function TermsCondition_SSI() {
  return (
    <>
      <section className="privacy_section">
        <Container>
          <div className="privacy_main">
            <div className="title_div mb-4">
              <h2 className="semi_title">TERMS & CONDITIONS SSI</h2>
            </div>
            <div className="mb-md-3 mb-3 ">
              <p className="text ">
                <strong>
                  “Smartshift Logistics Solutions Private Limited”
                </strong>{" "}
                or, <strong>“SG Transport”</strong> is a company which is, inter alia,
                engaged in the business of transportation of goods by road.
              </p>
            </div>
            <div>
              <p className="sub_title">GENERAL TERMS AND CONDITIONS</p>
              <ol>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Consignments entrusted to Smartshift Logistics Solutions
                    Private Limited (<strong>“SG Transport”</strong>) by you
                    (hereinafter referred to as{" "}
                    <strong>“Consignor/Sender/Customer”</strong> (as the case
                    may be)) for transportation shall be on agreed terms and
                    conditions as specified below.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Consignor/Sender/Customer (as the case may be)
                    acknowledge that, upon their acceptance of the terms and
                    conditions listed below, these terms and conditions shall be
                    binding on them and SG Transport. If the Consignor/ Sender/
                    Customer opts not to agree to these terms and conditions or
                    does not wish to avail the services provided by SG Transport, they
                    should uninstall the SG Transport app from their mobile phones and
                    discontinue the use of SG Transport’s services. Each time that the
                    Consignor/ Sender/ Customer sends any consignment through
                    SG Transport services, the Consignor/ Sender/ Customer
                    acknowledges the terms and conditions herein.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    These SG Transport Customer Terms and Conditions apply to the
                    services provided by SG Transport currently including the
                    following services: 1. Goods Transport by Road; 2. All India
                    Courier; and 3. Packers and Movers.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Goods Transport by Road; All India Courier; and Packers and
                    Movers.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Other than these General Terms and Conditions, the
                    Consignor/Sender/Customer (as the case may be) shall be
                    subject to the specific terms and conditions of Goods
                    Transport, All India Courier and Packers & Movers below,
                    depending on the services availed by them.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Consignor or Sender or Customer (as the case may be)
                    warrants and undertakes that all Consignments in respect of
                    which SG Transport is to provide its services are either owned by
                    the Consignor or Sender or Customer (as the case may be) or
                    legally in their possession or under their control, and that
                    the Consignor or Sender or Customer (as the case may be) is
                    able to deal with the Consignments as contemplated herein.
                    The Consignor or Sender or Customer (as the case may be)
                    agrees to indemnify SG Transport against any loss, damage or claim
                    made against SG Transport arising from any lack of authority of
                    the Consignor or Sender or Customer (as the case may be) to
                    contract with SG Transport for the Services, or any breach of the
                    warranty or undertaking given by the Consignor or Sender or
                    Customer (as the case may be) under this paragraph.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    SG Transport may vary or amend or change or update these Terms and
                    Conditions, from time to time entirely at its own
                    discretion. You shall be responsible for checking these
                    Terms and Conditions from time to time and ensure continued
                    compliance with the terms and conditions. The continued use
                    of SG Transport’s services by the Consignor or Sender or Customer
                    (as the case may be), after any such amendment or change in
                    the Terms and Conditions shall be deemed as your express
                    acceptance to such amended/changed terms and you also agree
                    to be bound by such changed/amended Terms and Conditions.
                    You agree that SG Transport’s services are subject to all
                    prevailing statutory taxes, duties, fees, charges and/or
                    costs, however denominated, as may be applicable from time
                    to time. It shall be your responsibility to ensure that you
                    comply with applicable laws on payment of taxes and pay the
                    prevailing charges and duties which shall form part of the
                    invoice raised by SG Transport.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Governing Law and Dispute Resolution: These SG Transport Customer
                    Terms and Conditions shall be governed by the laws of India
                    and subject to the mediation clause specified hereunder, the
                    courts in Bangalore shall have exclusive jurisdiction to
                    deal with any matter pertaining to these Terms and
                    Conditions. Any disputes between SG Transport and Consignor or
                    Sender or Customer (as the case may be) or anybody claiming
                    through or on behalf of the Consignor/Sender/Customer (
                    <strong>“Disputing Parties”</strong>) that cannot be settled
                    amicably within a period of 30 (thirty) days from the date
                    of the dispute may be resolved by mediation in accordance
                    with the Karnataka Civil Procedure (Mediation) Rules, 2005
                    before the Karnataka Mediation Centre, Bangalore (
                    <strong>“Institution”</strong>). A neutral mediator shall be
                    appointed by the Institution to facilitate the mediation
                    process. The Disputing Parties shall keep the mediation
                    confidential and not disclose to any person, unless required
                    to do so under applicable law.
                  </p>
                </li>
              </ol>

              <p className="sub_title">Governing Law and Dispute Resolution</p>
              <ol>
                <li className="text mb-md-3 mb-3">
                  <p>
                    These SG Transport Customer Terms and Conditions shall be governed
                    by the laws of India and subject to the mediation clause
                    specified hereunder, the courts in Bangalore shall have
                    exclusive jurisdiction to deal with any matter pertaining to
                    these Terms and Conditions. Any disputes between SG Transport and
                    Consignor or Sender or Customer (as the case may be) or
                    anybody claiming through or on behalf of the
                    Consignor/Sender/Customer (
                    <strong>“Disputing Parties”</strong>) that cannot be settled
                    amicably between within a period of 30 (thirty) days from
                    the date of the dispute may be resolved by mediation in
                    accordance with the Karnataka Civil Procedure (Mediation)
                    Rules, 2005 before the Karnataka Mediation Centre, Bangalore
                    (<strong>“Institution”</strong>). A neutral mediator shall
                    be appointed by the Institution to facilitate the mediation
                    process. The Disputing Parties shall keep the mediation
                    confidential and not disclose to any person, unless required
                    to do so under applicable law.
                  </p>
                </li>
              </ol>

              <p className="sub_title">
                Claims (As applicable to ‘Goods Transport by Road’ and ‘Packers
                and Movers’ below)
              </p>
              <ol>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Any claim (for accidents or negligence resulting in damage)
                    in respect of the goods shall be made in writing within 24
                    (twenty four) hours from the date of receipt and sent to{" "}
                    <a href="mailto:sgtransportwala1@gmail.com">
                      <b> sgtransportwala1@gmail.com </b>
                    </a>{" "}
                    for packers and movers service and{" "}
                    <a href="mailto:sgtransportwala1@gmail.com">
                      <b> sgtransportwala1@gmail.com </b>
                    </a>{" "}
                    for Goods Transport service. In case of damaged goods, the
                    Consignor/Customer (as the case may be) and/or consignee
                    needs to share photos of the damaged goods in case of Goods
                    Transport services and damaged packaging or goods in case of
                    packers and movers services, along with the description of
                    the damage. In absence of any such claims, made within the
                    period stipulated here, SG Transport shall not be liable to
                    process the same.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    When claiming refund against damage, the Consignor/Customer
                    must verify their identity as the original
                    Consignor/Customer of the goods. SG Transport may ask for relevant
                    information to validate the identity of the claimant in this
                    case. In case the identity of the claimant cannot be
                    validated by SG Transport, the refund request will not be
                    processed.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    For ‘Goods Transport by two-wheeler delivery’, SG Transport shall
                    be liable for any loss or damage to the goods directly
                    attributable to SG Transport or its agents to the extent of the
                    freight amount paid provided the amount so calculated shall
                    not exceed the value of the goods OR INR 1,500 (Indian
                    Rupees One Thousand Five Hundred), whichever is lower.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    For ‘Goods Transport by truck delivery’, SG Transport shall be
                    liable for any loss or damage to the goods directly
                    attributable to SG Transport or its agents to the extent of the
                    freight amount paid provided the amount so calculated shall
                    not exceed the value of the goods OR INR 5,000 (Indian
                    Rupees Five Thousand), whichever is lower.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    For the ‘Packers and Movers model’, SG Transport shall be liable
                    for any loss, theft or damage directly attributable to
                    SG Transport or its agents of (i) goods which have been packed in
                    a single layer packaging to the extent of INR 1500 (Indian
                    Rupees One Thousand Five Hundred) or the value of the goods,
                    whichever is lower; and (ii) goods which have been packed in
                    multi-layer packaging, to the extent of INR 5000 (Indian
                    Rupees Five Thousand) or the value of the goods, whichever
                    is lower.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Consignor/Customer hereby undertake and agree that,
                    should they so desire, they shall opt for additional
                    coverage to secure the goods from point of origin to point
                    of final destination at their own cost; provided, for any
                    goods above the value of INR 1,500 (Rupees One Thousand Five
                    Hundred in case of two-wheeler delivery and INR 5,000
                    (Rupees Five Thousand) for three and four wheeler delivery,
                    the Consignor/Customer will necessarily obtain insurance
                    coverage from point of origin to point of final destination
                    at their own cost.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    No commitment is made for time bound completion of service.
                    Any time of arrival/delivery provided at booking is an
                    estimate only and, there may be occasional delays for reason
                    outside SG Transport’s control. SG Transport shall not be liable for any
                    loss arising from such delays.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Customer shall specify the accurate details of the goods
                    at the time of booking, including nature of goods, quantity,
                    volume, specifications etc.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Reverse liability: In the event of mis-declaration of the
                    goods (including without limitation where the goods are
                    already damaged or damage other goods while under carriage
                    or are illegal goods/ consignment) the Consignor/Customer
                    shall be liable for any damages related to such mis declared
                    goods including consequential and third party damages.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Void liability: In the event of mis-declaration of the
                    goods, SG Transport shall not be liable for any claims on
                    compensation or the logistics-related costs or charges or
                    the declared value of goods nor statutory or legal
                    responsibilities of such goods.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Under no circumstances will SG Transport or any of its director,
                    officer, employee, agent or contractor be liable to the
                    Consignor/Customer or consignee for any indirect,
                    incidental, consequential, special or exemplary losses or
                    damages, mis-delivery, or non-delivery of consignment for
                    any reason whatsoever. More particularly, SG Transport shall not
                    be liable for any loss of income, profits, interests or
                    other consequential losses.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Refund Period: All eligible refunds shall be processed
                    within 7 – 10 working days from the day the claim has been
                    accepted by SG Transport upon submission of complete documents
                    pertaining to the dispute by the Consignor/Customer, except
                    where such refund cannot be processed due to reasons not
                    attributable to SG Transport.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Where the Consignor/Customer is registered under the GST
                    regulations, the same should be intimated to SG Transport through
                    the SG Transport App. Further, any change in status of GSTIN shall
                    also be intimated to SG Transport prior to initiation of the
                    service.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    SG Transport is a “goods transport agency” (GTA) under the Central
                    Goods and Services Tax Act, 2017 (GST) and has opted for tax
                    on reverse charge basis for transportation service rendered
                    to GST registered customers. Accordingly, in case the
                    Consignor/Customer is registered under GST provisions (as
                    per the information provided on the SG Transport App), the
                    Consignor/Customer is liable to pay the GST under reverse
                    charge mechanism (RCM) on the invoices raised by SG Transport.
                    Once Services are provided by SG Transport to the Customer, SG Transport
                    shall report details of such Services on the GST Portal of
                    the Government for enabling the Customer to pay requisite
                    taxes under the RCM within the prescribed statutory due
                    dates.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Consignor/Customer maybe contacted by SG Transport for
                    furnishing additional details required to process
                    compensation towards loss or damage of the goods. The
                    additional details requested may include, without
                    limitation, images to prove damage to the goods and/or bank
                    details of the Consignor/Customer to which the compensation
                    should be credited. SG Transport will not be liable for payment of
                    any compensation if the details requested by it are not
                    provided within 2 working days from the date on which the
                    initial e-mail request is sent to the Consignor/Customer.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Blocking of access: The Consignor/Customer acknowledges and
                    agrees that SG Transport may block their access to its services,
                    in whole or in part, at any time and for any reason, at
                    SG Transport's sole discretion, without prior notice or liability.
                    Such reasons may include, without limitation, violation of
                    these terms and conditions, applicable law, or SG Transport's
                    policies, misuse of SG Transport's services, security risks, or
                    fraudulent activities. SG Transport may restore the
                    Consignor's/Customer’s access at its sole discretion.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Pure Agent Relationship in Respect of Certain Costs Incurred
                    by SG Transport on Behalf of the Customer: In the event that the
                    Customer avails the services of SG Transport Wallet to make
                    hassle-free, quick, and seamless transactions in respect of
                    SG Transport Services, the Customer authorizes SG Transport to act as
                    their pure agent for procuring the services of Payment
                    Aggregators (“PAs”) and/or Payment Gateways (“PGs”) which
                    are linked to the recharge and maintenance of SG Transport Wallet.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    SG Transport neither intends to hold nor holds any title to the
                    services of PGs/PAs procured to recharge the SG Transport Wallet
                    of the Customer. The services of PGs/ PAs procured to
                    recharge the SG Transport Wallet is not for SG Transport’s own interest
                    but are solely made on behalf of the Customer to make hassle
                    free, quick, and seamless transactions in respect of SG Transport
                    Services.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Customer consents to reimburse SG Transport the charges for
                    the services of PGs/ PAs to recharge the SG Transport Wallet on
                    cost-to-cost basis.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    SG Transport agrees to charge the Customer only the actual cost
                    incurred by SG Transport in the capacity of a pure agent to
                    procure the services of PGs/ PAs to recharge the SG Transport
                    Wallet, in addition to the amount received from the Customer
                    for SG Transport Services.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Cash on Delivery Payment Term: If Consignor/Customer has
                    opted for cash on delivery payment option, the
                    Consignor/Customer must pay the full amount to the delivery
                    partner as reflected on the SG Transport app at the time of
                    completion of the services. The Payment made to the driver
                    partner shall be deemed to be made on behalf of SG Transport and
                    SG Transport shall not be liable for any additional payment that
                    the Consignor/Customer may choose to pay to the delivery
                    partner including by way of tips. In case of non payment/
                    deficit payment, SG Transport shall be entitled to levy additional
                    charges/ expenses, initiate legal recourse including but not
                    limited to suspension of the customer’s account or take
                    legal actions for recovery of such payments from the
                    Customer/ Consignor.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Cancellation: All cancellations made after driver allocation
                    may incur a cancellation fee basis company policies. The
                    same if any shall be communicated at the time of
                    cancellation.
                  </p>
                </li>
              </ol>

              <p className="sub_title">
                GOODS TRANSPORT BY ROAD - TERMS AND CONDITIONS
              </p>
              <ol>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The following terms and conditions relate to the Goods
                    Transport services provided by SG Transport. Goods Transport
                    services may be undertaken by two wheelers, three wheelers
                    or four wheelers. Consignors availing the Goods Transport
                    services provided by SG Transport agree to be bound by these terms
                    and any other general or specific terms and conditions
                    notified by SG Transport from time to time.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Consignors should adhere to following packaging instructions
                    when availing Goods Transport services: 1. Cover the goods
                    completely, securing the ends with tape. 2. For fragile
                    items, cover the same in bubble wrap ensuring corners and
                    edges are well protected. 3. Use stretch wrap for items that
                    might shift to keep them snugly in place. 4. For items being
                    moved in a box, fill the void in the box with crumpled paper
                    to stop the items from shifting. For fragile items, layer
                    the bottom of the box with cushioning material before
                    placing your items inside. 5. While sealing use strong tape
                    designed for shipping, such as pressure-sensitive packing
                    tape or water-activated tape. 6. Avoid using string instead
                    of tape.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Consignor understands that using SG Transport’s services for
                    sending fragile items is at Consignor’s own risk. If the
                    consignment includes fragile or high-risk items, please
                    ensure that packaging of such items is done carefully in the
                    manner stated above. SG Transport shall not be liable for any
                    damage caused to goods due to poor packaging by the
                    Consignor.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Consignor warrants that they are the owner or the
                    authorized agent of the owner of the goods / articles
                    transported and is authorised to accept the terms and
                    conditions herein.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Consignor is required to fill out all the accurate
                    particulars of consignment and trip details into the mobile
                    application while booking a consignment for transportation,
                    all of these details constitute the ‘Goods Forwarding Note’.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    SG Transport shall, upon receipt of the Goods Forwarding Note from
                    the Consignor, for booking of the consignment to be
                    transported, issue a Goods Receipt/ Consignment Note to the
                    Consignor.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Consignor is responsible for all goods transported
                    through SG Transport. Consignor will only use SG Transport services for
                    legal purposes and shall not commit any illegality or use
                    SG Transport services for any unlawful purpose. The Consignor
                    warrants to SG Transport that the description of the consignment
                    as noted in the application conforms accurately to the
                    actual content of the consignment thereof and such
                    consignment does not form part of the Prohibited Items. If
                    the consignment contains any such items or material, the
                    Consignor agrees and undertakes to fully indemnify SG Transport
                    and/or its agents for any loss, damages, costs, expenses,
                    penalties, fines, liability thereof that may be incurred by
                    SG Transport or agents with regard to the said item or material.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    It is expressly understood by the Consignor and SG Transport that
                    all consignments agreed to be delivered by SG Transport are on a
                    “said-to-contain” basis i.e., SG Transport shall have the right,
                    but will be under no obligation to verify the contents of
                    the consignment declared by the Consignor. The Consignor
                    shall undertake to make proper, true, fair, correct and
                    factual declaration regarding description and value of the
                    consignment.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    At the time of booking, the Consignor will be required to
                    provide a declaration stating the value of the consignment
                    and the description of materials in the consignment and the
                    same shall be binding on the Consignor.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    SG Transport will use the Consignor and consignee’s information as
                    shared with it, to update and inform the Consignor /
                    consignee through SMS, push notifications, Whatsapp and/ or
                    email or any other form of communication as may be mutually
                    decided between SG Transport and the Consignor, regarding the
                    delivery status of the consignment and obtain feedback from
                    the Consignor / consignee regarding the said service only so
                    as to improve the customer experience with SG Transport.
                    Additionally, SG Transport may use the Consignor’s behavioural
                    information reflected via usage of the SG Transport app by the
                    Consignor, for its internal analysis and targeted marketing
                    and the Consignor hereby agrees to such use by SG Transport.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Consignor agrees to indemnify and hold SG Transport and its agents
                    harmless for any loss, damages, costs, expenses, penalties,
                    fines, liabilities, of any nature whatsoever incurred or
                    suffered by SG Transport and its agents due to any acts or
                    omissions, breach of applicable law and/ or customer/ third
                    party claims attributable to the Consignor.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Consignor shall not book any consignment containing any
                    of the following items (<strong>“Restricted Items”</strong>
                    ): (i) pornographic material; (ii) dry ice used for
                    packaging or temperature control; (iii) human corpses,
                    organs or body parts; (iv) flammable items (firecrackers,
                    oil cans, adhesives, paint cans), explosives (arms,
                    ammunition, fireworks, flares, gunpowder, airbag inflators);
                    (v) fire extinguishers; (vi) alcohol / tobacco /
                    prescription medicines / drugs /contrabands/ narcotics /
                    psychotropic substances poisonous goods, toxic and
                    infectious items; (vii) corrosive items such as acids,
                    chemicals etc; (viii) radioactive material; (ix) highly
                    perishable food items; (x) expensive electronics including
                    but not limited to mobile phones, ipads, laptops, smart
                    watches etc. (xi) livestock; (xii) pets and animals; (xiii)
                    Non packaged perishables; (xiv) platinum, gold, silver,
                    jewellery, gems, precious, semi-precious metals or stones in
                    any form; (xv) gambling devices, lottery tickets; and (xvi)
                    any diagnostic specimens, hazardous or bio-medical waste.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Consignor acknowledges that the above list may be
                    updated from time to time either at the URL where these
                    terms are made available or as otherwise notified to the
                    Consignor.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Further, Consignors will not hand over any secure
                    documents/articles including, but not restricted to
                    education certificates, passport, Aadhar Cards, bank
                    statements, credit cards, debit cards, bank cheques and / or
                    currency items, passports amongst other documents (
                    <strong>“Restricted Documents/Articles”</strong>). SG Transport is
                    not licensed to carry Restricted Documents/Articles and
                    shall have no liability in such cases if such documents are
                    handed over for delivery by the Consignor.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    In the event the Consignor requests transportation or
                    undertakes transportation by misrepresentation of any
                    illegal or unlawful or prohibited items as mentioned above
                    or which is otherwise restricted under any applicable law,
                    SG Transport or its agent has the right to report the same to the
                    law enforcement authorities. SG Transport has a zero tolerance
                    policy towards misuse of its services for transportation of
                    illegal/ prohibited items.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Consignor is required to provide the accurate address for
                    delivery at the time of booking the consignment. It is not
                    possible to entertain any request for updating the delivery
                    address once the consignment leaves the place of origin.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    SG Transport reserves its right to refuse the booking of any
                    consignment without assigning any reason whatsoever.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    In the event, during transit of the Consignor’s consignment
                    from pick-up location to drop-off location or while
                    undertaking the transport services, if police or other law
                    enforcement agencies demand display of the items for
                    verification, the delivery agents of SG Transport shall display
                    the consignment to such authorities. In the event any
                    regulatory authorities levy any penalties/ fines to the
                    driver partner / SG Transport due to any acts of the Consignor
                    which are contrary to any applicable laws, rules,
                    regulations, guidelines. The Consignor undertakes to
                    indemnify SG Transport.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    When loading the vehicle prior to transportation, the
                    Consignor agrees not to exceed the weight and size details
                    specified by the Consignor at the time of booking. Please
                    ensure that the items are within these limits to ensure safe
                    transport and compliance with SG Transport’s guidelines and
                    applicable laws. We have the right to reject any goods which
                    exceed the weight and size specified at the time of booking.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Consignor understands and agrees that the consignee of
                    the goods should be available at the drop-off location at
                    the time communicated for delivery of the goods. In the
                    event the consignee is not available at the drop-off
                    location or refuses to take delivery, the Consignor will be
                    contacted. In case the Consignor is not available, such
                    consignments may be returned at the drop-off location or to
                    the pick-up location or disposed of in any other manner
                    suitable and deemed practical by SG Transport or its agents.
                    Additionally, in case of non-acceptance of the return to
                    origin (<strong>“RTO”</strong>) consignment by the Consignor
                    or in case the Consignor is not reachable for RTO
                    consignment, SG Transport reserves the right to levy suitable
                    demurrage / incidental charges for extended storage of such
                    products.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Consignments cannot be delivered to PO boxes or postal
                    codes. Consignments are delivered to the consignee’s address
                    as provided by the Consignor, but not necessarily to the
                    named consignee personally. Consignments to addresses with a
                    central receiving area will be delivered to that area only.
                    We do not provide door step delivery.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    In the event the Consignor opts for ancillary services such
                    as loading-unloading (<strong>“Load Assist”</strong>) in the
                    course of transportation of their goods, the Consignor will
                    be charged for the same, which shall be included in the
                    composite services undertaken.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    SG Transport may provide load assist services in some territories
                    or for some orders. If the Consignor chooses to avail such
                    services, consignor shall ensure that they shall be present
                    or authorise someone to be present at the time of availing
                    such services.
                  </p>
                </li>

                <li className="text mb-md-3 mb-3">
                  <p>
                    If you choose to avail the services of Load Assist, the
                    following conditions will be applicable:
                  </p>
                  <ol>
                    <li>
                      {" "}
                      <p className="text mb-md-3 mb-3">
                        Packaging, Assembly-Disassembly, Dismantling & Rope
                        Pulling of goods are not included.
                      </p>
                    </li>
                    <li>
                      {" "}
                      <p className="text mb-md-3 mb-3">
                        Technical Assistance are not included : If any machine,
                        appliance, or electronic gadgets require technical
                        assistance of the manufacturer for locking/unlocking, it
                        is the customer's responsibility to arrange for it as
                        SG Transport does not offer these services.
                      </p>
                    </li>
                    <li>
                      {" "}
                      <p className="text mb-md-3 mb-3">
                        Goods heavier than 50 kg or that which cannot be lifted
                        by 2 persons cannot be moved using this service. Eg:
                        King/queen size cots, Big wardrobe/ Almirahs, 5 seater
                        sofa, other such goods bigger than 7 feet, etc.
                      </p>
                    </li>
                  </ol>
                </li>

                <li className="text mb-md-3 mb-3">
                  <p>
                    SG Transport shall not be liable for any delay in pickup,
                    mis-delivery, non-delivery or loss or damage to it caused on
                    account of an act of God, force majeure and or circumstances
                    like war, epidemics, pandemics, acts of public enemies
                    strikes, embargoes, local disputes, riots/ civil commotion,
                    political and other disturbances or accidental fire,
                    accident of vehicle carrying the goods, arrest, restraint or
                    seizure under legal process, order or restrictions or
                    prohibition imposed by any governmental authority,
                    explosions or any other cause reasonably beyond the control
                    of SG Transport.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Please note that the time of arrival/delivery provided at
                    booking is an estimate. Any time of arrival/delivery
                    provided at booking is an estimate only and, there may be
                    occasional delays for reason outside SG Transport’s control.
                    SG Transport shall not be liable for any loss arising from such
                    delays..
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Directors, owners, partners and shareholders of SG Transport shall
                    not be personally liable for any claims or liabilities
                    arising out of service failures including those resulting
                    from situations, circumstances, omissions, errors, failures
                    or misleading statements/guidance from any employees of
                    SG Transport or of its channel partners or of its driver partners.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Consignor shall be liable for the preparation and/or
                    generation of the E-way bill (including Part-A and Part-B of
                    the E-way bill) and it shall be the sole responsibility of
                    the Consignor to ensure that all the details provided in
                    such E-way bill are true and/or accurate. Further, the
                    Consignor shall ensure the particulars of the vehicle are
                    correctly mentioned in the E-way bill and provide a copy of
                    the E-way bill to the driver at the start of the trip. In
                    case of any vehicle breakdown or delay in the delivery of
                    the consignment, the Consignor shall be obligated for making
                    any necessary or required changes in the Part-B of the E-way
                    Bill, in a timely manner and furnishing a copy of the same
                    to the driver. In the event of failure by the Consignor, the
                    Consignor shall be solely liable for any repercussions for
                    non-compliance under applicable Law. SG Transport shall not be
                    responsible for actions of the authorities due to
                    misdeclaration, the Consignor will have to deal directly
                    with all tax and statutory authorities in case of any
                    notices related to the e-waybill from any tax / statutory
                    authorities.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Notwithstanding any other remedy available to SG Transport, SG Transport
                    shall have a lien over all goods/ consignments in its
                    possession or under its control in respect of any sums due
                    to SG Transport by the Consignor. Notwithstanding that SG Transport
                    shall have a lien over any goods/ consignments, the
                    Consignor shall continue to be liable for any and all
                    charges arising from the provision of the Services until all
                    sums due to SG Transport have been received by it. If the
                    consignee does not take delivery of the consignment or it
                    remains undelivered due to any reason such as wrong or
                    incomplete address or refusal by consignee to pay any
                    applicable duties / taxes / charges or containing Prohibited
                    Items or if the packaging of a consignment is damaged to the
                    extent that repacking is not possible resulting in non
                    delivery or the consignment is found as likely to cause
                    damage to other goods or cause injury to individuals, then
                    the Consignor shall still be liable to pay freight charges
                    and all other dues and charges to SG Transport. In case of the
                    goods remains undelivered beyond 48 (forty eight) hours from
                    the date of tendering the consignment for delivery, then
                    demurrage / warehouse charges at such other rates as may be
                    fixed by SG Transport from time to time. Further, if the
                    consignment is not received or claimed within 7 days from
                    the date of tendering the consignment for delivery for the
                    first time, then SG Transport shall have the right to proceed with
                    the sale of the goods of the consignment to realize all its
                    dues. SG Transport reserves the right to levy suitable demurrage /
                    incidental charges for extended storage of such goods.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Enterprise customers who avail SG Transport’s services through API
                    integration shall also be subject to these SG Transport terms and
                    conditions.
                  </p>
                </li>
              </ol>

              <p className="sub_title">
                ALL INDIA COURIER SERVICES - TERMS AND CONDITIONS
              </p>

              <ol>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The following terms relate to All India Courier services
                    provided by SG Transport. Users availing the All India Courier
                    services provided by SG Transport agree to be bound by these terms
                    and any other general terms and conditions notified by
                    SG Transport from time to time. SG Transport may provide these services
                    by itself or in association with third party service
                    providers.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    With respect to All India Couriers, the Sender acknowledges
                    that, they have read, understood and agreed to the terms and
                    conditions of the third parties whose services are engaged
                    by the Sender in relation to any services availed on the
                    Platform of SG Transport. The Sender warrants that they are the
                    owner or the authorized agent of the owner of the parcels
                    transported and are authorised to accept the terms and
                    conditions herein.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Packaging the goods appropriately is the responsibility of
                    the Sender. Sender should ensure goods are packaged in a
                    manner which can withstand reasonable care and handling. The
                    Sender should adhere to following packaging instructions
                    when availing the All India Courier services:
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The items shall be packed using carton boxes and the same
                    shall be sealed using proper packaging tapes
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Documents shall be packed using the envelopes with proper
                    sealing.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>Do not use damaged or old boxes for packaging.</p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>Remove any old labels or barcodes.</p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Avoid using low quality adhesive tapes, kraft paper tape,
                    cellophane, masking tapes and springs or ropes.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>Only one box/envelope is allowed per AWB number.</p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    In case the shipment is inappropriately packed and/or it
                    contains any of the prohibited items to the knowledge of
                    SG Transport, the shipment may be flagged as rejected by the
                    pickup person assigned with such tasks.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The maximum allowable size of the shipment while using these
                    services is 100,000 cubic cms.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Sender is required to fill out the particulars of the
                    parcel while booking a parcel for delivery.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Sender warrants to SG Transport that the description of the
                    parcel as noted at the time of booking on the <b>app</b>{" "}
                    conforms accurately to the actual content thereof and it
                    does not contravene the provisions of any applicable law.
                    The Sender shall remain solely liable for any consequences
                    arising out of any false or wrongful declaration.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Sender shall provide complete and accurate address of
                    the Sender and the Recipient along with valid contact
                    telephone numbers and correct Postal Index Number (PIN
                    code). Any service failure arising out of any defect in such
                    details shall be at the sole responsibility and at risk of
                    the Sender.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Not with standing any other remedy available to SG Transport,
                    SG Transport shall have a lien over all parcels in its possession
                    or under its control in respect of any sums due to SG Transport by
                    the Sender. Notwithstanding that SG Transport shall have a lien
                    over any parcel, the Sender shall continue to be liable for
                    any and all charges arising from the provision of the
                    services provided by SG Transport until all sums due to SG Transport
                    have been received by it. If the Recipient does not take
                    delivery of the parcel or it remains undelivered due to any
                    reason such as wrong or incomplete address or refusal by the
                    Recipient to pay any applicable duties / taxes / charges or
                    containing prohibited items or if the packaging of a parcel
                    is damaged to the extent that repacking is not possible
                    resulting in non delivery or the parcel is found as likely
                    to cause damage to other goods or cause injury to
                    individuals, then the Sender shall still be liable to pay
                    freight charges and all other dues and charges to SG Transport. In
                    case the parcel remains undelivered after 3 (three) delivery
                    attempts from the date of tendering the parcel for delivery,
                    then demurrage / warehouse charges at the rate of 0.1% (zero
                    point one percent) of the parcel invoice value per day will
                    be charged or at such other rates as may be fixed by SG Transport
                    from time to time. Further, if the parcel is not received or
                    claimed within 15 days from the date of tendering the parcel
                    for delivery for the first time, then SG Transport shall have the
                    right to proceed with the sale of the goods to realize all
                    its dues. Additionally, case of non-acceptance of the return
                    to origin (<strong>“RTO”</strong>) parcel by the Sender or
                    in case the Sender is not reachable for RTO parcel, SG Transport
                    reserves the right to levy suitable demurrage / incidental
                    charges for extended storage of such parcel.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Directors, owners, partners and shareholders of SG Transport shall
                    not be personally liable for any claims or liabilities
                    arising out of service failures including those resulting
                    from situations, circumstances, omissions, errors, failures
                    or misleading statements/guidance from any employees of
                    SG Transport or of its channel partners or of its authorized
                    agents.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Parcels cannot be delivered to PO boxes or postal codes.
                    Parcels will be delivered to the Recipient’s address as
                    provided by the Sender but not necessarily to the named
                    Recipient personally. Parcels to addresses with a central
                    receiving area will be delivered to that area only.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Pickup of parcels will not be available on Sundays or public
                    holidays.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Parcels with a declared value exceeding INR 49,999 (Rupees
                    Forty Nine Thousand Nine Hundred Ninety Nine) cannot be
                    shipped via SG Transport.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Parcels with incorrect weight and dimensions would go on
                    hold and would affect the actual delivery date. SG Transport shall
                    not be liable for any losses incurred due to parcels kept on
                    hold because of incorrect weight and dimensions.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    It is expressly understood by the Sender and SG Transport that all
                    parcels agreed to be delivered by SG Transport are on a
                    “said-to-contain” basis i.e., SG Transport shall have the right
                    but will be under no obligation to verify the contents of
                    the parcels declared by the Sender. The Sender shall
                    undertake to make proper, true, fair, correct and factual
                    declaration regarding description and value of parcels.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    SG Transport shall have the right but not an obligation to open /
                    inspect the parcels at the time of booking or during
                    transit.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    SG Transport will use the Sender / Recipient / booking customer
                    information as shared with it, to update and inform the
                    Sender / Recipient through SMS, push notifications, Whatsapp
                    and/ or email or any other form of communication as may be
                    mutually decided between SG Transport and the Sender, regarding
                    the pickup and delivery status of the product / goods,
                    returns and weight discrepancy and obtain feedback from the
                    Sender / Recipient regarding the said service only so as to
                    improve the customer experience with SG Transport
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    All parcels are booked by SG Transport in good faith in respect of
                    the contents thereof. The parcels shall not contain any
                    items or materials which are prohibited/ banned, dangerous,
                    hazardous or considered contraband by any applicable law. If
                    the parcel contain any such items or material, the Sender
                    agrees and undertakes to fully indemnify SG Transport, third party
                    service providers or its agent for any loss, damages, costs,
                    expenses, penalties, fines, liability thereof by SG Transport,
                    third party service providers or its agent with regard to
                    the said item or material.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Sender agrees to indemnify and hold SG Transport harmless for
                    any loss, damages, costs, expenses, penalties, fines,
                    liabilities, of any nature whatsoever incurred or suffered
                    by SG Transport due to any acts or omissions, breach of applicable
                    law and/ or customer/ third party claims solely attributable
                    to the Sender.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Sender shall not book any parcel containing any of the
                    following items (<strong>“Restricted Items”</strong>): (i)
                    highly perishable food items; (ii) electrical items
                    (induction stove, iron box, electric kettle etc); (iii)
                    liquid bleach; (iv) livestock; (v) flammable items
                    (firecrackers, oil cans, adhesives, paint cans), explosives
                    (arms, ammunition, fireworks, flares, gunpowder, airbag
                    inflators); (vi) fire extinguishers; electric
                    lighter/cigarette; (vii) platinum, gold, silver, artificial
                    jewellery, gem, precious, semi-precious metals or stones in
                    any form; (viii) bricks; (ix) alcohol / tobacco / medicines
                    / drugs /contrabands/ narcotics / psychotropic substances
                    poisonous goods, toxic and infectious items; (x) high
                    capacity batteries such as car batteries, generator
                    batteries, machinery parts containing oil, grease, fuel or
                    batteries and other automobile parts; (xi) corrosive items
                    such as acids, chemicals etc; (xii) radioactive material;
                    (xiii) gambling devices, lottery tickets; (xiv) pornographic
                    material; (xv) dry ice used for packaging or temperature
                    controlled; and other items considered contraband under the
                    Indian Postal law; (xvi) human corpses, organs or body
                    parts; (xvii) any diagnostic specimens, hazardous or
                    bio-medical waste; and (xviii) time sensitive documents.
                  </p>
                </li>
              </ol>

              <p className="text mb-md-3 mb-3">
                The Sender acknowledges that the above list may be updated from
                time to time either at
                <b>https://sgtransportwala.com/</b>terms-of-service where these
                terms are made available or as otherwise notified to the Sender.
              </p>

              <ol>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Further, Senders will not hand over any original documents
                    including but not restricted to education certificates,
                    passport, Aadhar Cards, bank statements, credit cards, debit
                    cards, bank cheques and / or currency items, passports
                    amongst other documents ("
                    <strong>Restricted Documents</strong>"). SG Transport is not
                    licensed to carry Restricted Documents and shall have no
                    liability in such cases if such documents are handed over
                    for delivery by the Sender.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    In the event SG Transport or its agents or third party service
                    providers becomes aware that the Sender is using, or used
                    the service to transport any illegal or unlawful or
                    prohibited items as mentioned above or which is otherwise
                    restricted under any applicable law, SG Transport, or its agents
                    or third party service providers has the right to report the
                    same to the law enforcement authorities.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Parcel to be moved: i. Cannot exceed 15 kg in volumetric
                    weight. ii. Cannot exceed 75 cm x 75 cm x 75 cm in
                    dimensions. iii. The contents of the parcel should be
                    permitted for express movement. iv. Cannot contain any
                    Notified Items or Restricted Documents. If the items i.e.,
                    any Notified Items or Restricted Documents are found in the
                    parcel booked for road movement, the items might be
                    forfeited or disposed of otherwise without any prior
                    notification obligation or liability of SG Transport.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Sender shall provide the actual weight along with the
                    Length, Breadth and Height at the time of booking. The
                    volumetric weight is calculated by inputting the{" "}
                    {"Length(cms) X Breadth(cms) X Height(cms)"}/5000. The
                    highest amongst the actual weight and the volumetric weight
                    will be considered for price calculation.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The estimated date of delivery (“<strong>EDD</strong>”)
                    shown while booking any standard delivery may vary due to
                    operational challenges.. Any time of arrival/delivery
                    provided at booking is an estimate only and, there may be
                    occasional delays for reason outside SG Transport’s control.
                    SG Transport shall not be liable for any loss arising from such
                    delays.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The estimated date of delivery (“<strong>EDD</strong>”)
                    shown while booking express deliveries /priority services/
                    super-fast deliveries may also vary due to challenges beyond
                    our control. Any time of arrival/delivery provided at
                    booking is an estimate only and, there may be occasional
                    delays for reason outside SG Transport’s control. SG Transport shall not
                    be liable for any loss arising from such delays.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Delivery address cannot be updated once the parcel leaves
                    the city of origin. However, the Sender can change contact
                    details if duly communicated to SG Transport through the support
                    ID. Any change in such information may lead to increasing
                    the delivery timelines which will be the sole liability and
                    responsibility of the Sender.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    SG Transport reserves its right to refuse the booking of any
                    parcel without assigning any reason whatsoever.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    In case of 6 (six) failed pickup attempts for inter-state
                    courier services, the pick-up request will be cancelled by
                    SG Transport and the refund will be processed to the original mode
                    of payment by SG Transport subject to the bank’s refund
                    guidelines.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    In the event, during transit of the Sender’s parcel from
                    pick-up location to drop-off location or while undertaking
                    courier services, if the police or other law enforcement
                    agencies demand display of the items in the parcel for
                    verification, the third party service providers or delivery
                    agents of SG Transport shall have the right to display the items
                    in the parcel to such authorities.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Sender understands and agrees that the Recipient of the
                    parcel should be available at the drop-off location at the
                    time communicated for delivery of the items. In the event
                    the Recipient is not available at the drop-off location or
                    refuses to take delivery or cannot be located by the
                    delivery agent of SG Transport, the Sender will receive a
                    notification either through the App and/or SMS and/or a
                    phone call (“<strong>Delivery Failed Message</strong>”). On
                    receipt of Delivery Failed Message, it shall be the Sender’s
                    responsibility to take re-delivery of the parcel at the
                    identified location on payment of additional cost which may
                    be communicated by SG Transport. In the event the Sender refuses
                    to pay the cost of re-transportation or re-delivery of the
                    parcel for which a Delivery Failed Message has been sent to
                    the Sender, the Sender hereby authorizes SG Transport to hold the
                    parcel in lieu of its claim of re-transportation of the
                    parcel and subject to payment of the said amount release the
                    items in the Sender’s favour.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Recipient may authorize SG Transport and SG Transport may agree to
                    the following: i. to leave parcels without signing the
                    acknowledgment of receipt at the delivery address due to the
                    unavailability of any individual to collect the parcels; or
                    ii. To deliver in the letterbox/locker box. In such cases,
                    SG Transport will provide proof of delivery, on request, and will
                    not be held liable for any loss or damage of any parcel.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    SG Transport shall not be liable for any delay in pickup,
                    mis-delivery, non-delivery or loss or damage it to caused on
                    account of an act of God, force majeure and or circumstances
                    like strikes, riots, political and other disturbances or
                    accidental fire, accident of vehicle carrying the parcels
                    explosions or any other cause reasonably beyond the control
                    of SG Transport.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    If the actual weight of the parcel is found to be more than
                    the designated value mentioned at the time of booking,
                    SG Transport may contact the Sender to collect the deficit amount.
                    SG Transport will be at liberty to return the parcel if SG Transport
                    does not hear from the Sender or the balance payment is not
                    made within 36 (thirty six) hours after receiving the
                    payment link by the Sender. The decision of SG Transport in this
                    regard will be final and binding.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Items deemed unfit for air movement are prohibited from
                    being booked for delivery via air and the same cannot be
                    delivered by SG Transport via air.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    All refund concerns should be raised within 24 (twenty four)
                    hours of delivery of the parcel or the shipment status
                    changing to delivered. Once the claim is registered, the
                    Sender to provide the GST invoices of the lost or damaged
                    items in parcel within 48 (forty eight) hours. The Sender
                    acknowledges the following limits in respect of SG Transport’s
                    liability:
                  </p>
                </li>
              </ol>

              <div className="SSI_table_holder">
                <SSI_table_holder />
              </div>

              <p className="sub_title">
                PACKERS AND MOVERS SERVICES - TERMS AND CONDITIONS
              </p>

              <ol>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The following terms relate to packers and movers services
                    provided by SG Transport. These services are rendered in
                    association with third party vendors. Customers availing the
                    packers and movers services provided by SG Transport agree to be
                    bound by these terms and any other general terms and
                    conditions notified by SG Transport from time to time.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    In the below terms and conditions, usage of the following
                    words will have the following meaning:
                    <br />
                    <br />
                    <strong>“Article”</strong> means each separate item carried
                    or moved by SG Transport. For the avoidance of doubt, where two or
                    more objects are packed together in one carton, such items
                    packed in a carton shall cumulatively be one Article.
                    <br />
                    <br />
                    <strong>“Customer”</strong> means the person contracting
                    with SG Transport to provide the Services, whether or not they are
                    the owner of the Goods.
                    <br />
                    <br />
                    <strong>“Goods”</strong> means the thing or things in
                    relation to which Packers and Movers Services are to be
                    provided but excluding coins, cash, bank notes cheques,
                    money orders, postal orders, national saving certificates,
                    premium bonds, travel tickets, passport, securities,
                    manuscripts or documents of any description, Jewellery,
                    perishable goods, hazardous materials like Crackers,
                    Explosives, Chemicals, Filled Gas Cylinders, Battery Acids,
                    Inflammable Oils; such as Diesel, Petrol, Kerosene,
                    Gasoline, Narcotics & Contraband items and other items
                    prohibited under law.
                    <br />
                    <br />
                    <strong>“Packing Material”</strong> shall mean Film roll,
                    bubble wrap, foam sheet, carton box, corrugated boxes or any
                    other such material used for packing the goods.
                    <br />
                    <br />
                    <strong>“Peak Days”</strong> shall mean any day(s) between
                    28th of a calendar month to the 3rd of the following month,
                    weekends, national holidays as well as auspicious days.
                    <br />
                    <br />
                    <strong>“Quotation”</strong> means the proposal shared by
                    SG Transport to the Customer with the proposed order cost and
                    other terms and conditions shall be set out.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Subject to the terms of the Quotation, SG Transport agrees to
                    provide the following services, to its Customers:
                    <br />
                    <br />
                    Packers and Movers Services:: (a) collect the goods from the
                    location designated by the Customer; (b) pack the Goods as
                    appropriate by way of either single layer packing or multi
                    layer packing as agreed between SG Transport and the Customers;
                    and (c) transport the Goods to the location designated by
                    the Customer.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Services are provided between 6 a.m. and 6 p.m. from
                    Monday to Friday, excluding public holidays. Unless
                    otherwise agreed by SG Transport, upon payment of surcharge,
                    SG Transport does not normally perform the Services on Saturday,
                    Sunday, Peak Days or any public holiday. Where the Services
                    are not completed within the normal working hours on the
                    dates stipulated in the quotation, SG Transport may, upon the
                    request of the Customer, continue to perform the Services
                    beyond the normal working hours for a surcharge or carry on
                    the Services on subsequent dates to be agreed with the
                    Customer at an extra charge.
                  </p>
                </li>

                <li className="text mb-md-3 mb-3">
                  <p>
                    Any Quotation submitted by SG Transport may be accepted by the
                    Customer on the App or by either signing and returning the
                    acceptance form attached to the Quotation, or by instructing
                    SG Transport to perform the Services pursuant to the terms of the
                    Quotation. The Quotation may be withdrawn or revised by
                    SG Transport prior to acceptance. Any Quotation will be based upon
                    the details provided to SG Transport by the Customer as regards
                    the Services requested by the Customer in relation thereto.
                    If any such detail provided by the Customer is incorrect,
                    SG Transport can adjust its charges accordingly.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Once accepted, the Quotation and all the terms therein shall
                    be binding. In so far as the term or terms of the Quotation
                    are inconsistent with the terms herein, the terms of the
                    Quotation shall prevail to the extent of the inconsistency.
                    If the Customer wishes to cancel or terminate the Contract
                    before its full performance by SG Transport, the Customer shall be
                    liable to pay a cancellation or early termination charge as
                    specified in the Quotation to compensate SG Transport for any loss
                    it shall sustain by reason of such cancellation or early
                    termination. Such charge shall be without prejudice to any
                    rights that SG Transport may have against the Customer in relation
                    to such early termination.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    SG Transport, to the exclusion of the Customer, shall decide how
                    the Services are to be provided, and may vary its decision
                    from time to time.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Any period of time within which SG Transport is to perform any
                    part of the Services is an estimate only, and whilst SG Transport
                    will use all reasonable endeavours to perform the Services
                    at and within the agreed time, it shall not be liable for
                    any loss or damage whatsoever (whether direct, indirect or
                    consequential) arising from a failure to do so.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Customer shall ensure that adequate access is available
                    to all relevant premises for the purpose of performing the
                    Services.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The Customer shall: (i) in respect of the Packers and Movers
                    Services, promptly supply SG Transport with any information
                    concerning the nature of the Goods which SG Transport may request;
                    (ii) in relation to the Goods, comply with all applicable
                    laws, regulations and requirements relevant to SG Transport’s
                    provision of the Packers and Movers Services; (iii) not
                    submit any Goods which are or include any dangerous,
                    explosive, corrosive or other substance harmful to either
                    person or the property of SG Transport or of others.
                    <br />
                    <br />
                    The Customer agrees that if any Goods are submitted in
                    contravention of this paragraph and loss or damage is
                    thereby caused to SG Transport or its partner (whether directly or
                    indirectly), the Customer will indemnify SG Transport or its
                    partner against such loss or damage.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    While rendering the Packers and Movers Services, SG Transport’s
                    charges would not include: (i) split pickup / multiple
                    pickup and/or deliveries; (ii) plant removals from the
                    ground / crating of any item if not mentioned in the
                    respective Quotation; (iii) long carry society/elevator
                    charges and parking charges; (iv) vehicle detention, if any;
                    (v) storage in transit; (vi) any Government taxes or Octroi/
                    Mathadi /Toll / Entry Tax/Labor Union Charges in any state,
                    if applicable; (vii) collection or delivery using stairs
                    above second floor (if service lift not provided); and
                    (viii) special handling charges for items which cannot be
                    accessed through elevator (hoisting/stair carry).
                  </p>
                </li>

                <li className="text mb-md-3 mb-3">
                  <p>
                    SG Transport reserves rights to pick the Packing Material. If the
                    Customer does not return the Packing Material on the day of
                    the delivery, and retains the same, the Customer will be
                    charged for the Packing Material at the rate of INR 70
                    (Rupees Seventy) per carton.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    SG Transport shall, as soon as is practical after receiving the
                    Goods, provide the Customer with a list of items packed for
                    validation. The list shall not specify the contents of any
                    closed container and shall not validate if the Goods are in
                    good, or any particular, state or condition. Customer should
                    validate the list and all items packed.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Customer should ensure that a representative is present at
                    the site of packing and drop off to review and validate the
                    list of items. Customer should not hurry or interfere in the
                    process unnecessarily.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    In consideration of the provision of the Services by SG Transport,
                    the Customer shall pay to SG Transport: (i) such charges for the
                    Services as quoted in the Quotation; (ii) any out of pocket
                    expenses incurred by SG Transport in the provision of the
                    Services; and (iii) any additional charges which are
                    incurred by SG Transport by reason of the Customer having altered
                    his/her instructions to SG Transport in relation to the Services.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Notwithstanding any other remedy available to SG Transport, SG Transport
                    shall have a lien over all Goods in its possession or under
                    its control in respect of any sums due to SG Transport by the
                    Customer. Notwithstanding that SG Transport shall have a lien over
                    any Goods, the Customer shall continue to be liable for any
                    and all charges arising from the provision of the Services
                    until all sums due to SG Transport have been received by it. If
                    SG Transport exercises its right of lien on the Goods and such
                    lien is not discharged within [1 (one)] month, then SG Transport
                    shall be irrevocably authorised to sell or otherwise dispose
                    of all or any of the Goods subject to the lien and apply the
                    proceeds in or towards payment of the sums due to SG Transport,
                    without notice being required to be given to the Customer.
                    In case of the Goods remains undelivered beyond 48 (forty
                    eight) hours from the date of delivery, then demurrage /
                    warehouse charges at such other rates as may be fixed by
                    SG Transport from time to time. Further, if the Goods are not
                    received or claimed within 7 (seven) days from the date of
                    tendering the Goods for delivery for the first time, then
                    SG Transport shall have the right to proceed with the sale of the
                    Goods to realize all its dues. SG Transport reserves the right to
                    levy suitable demurrage / incidental charges for extended
                    storage of such Goods.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Notwithstanding anything to the contrary herein, in respect
                    of the Packers and Movers Services, SG Transport shall in no event
                    be liable (whether in negligence or under contract) for: (i)
                    loss or damage caused by any event of force majeure
                    including, without limitation, storm, fire, flood,
                    explosion, theft, acts done with malicious intent by any
                    person, or any other event outside the control of SG Transport;
                    (ii) loss or damage arising from the natural deterioration
                    of the Goods; (iii) loss or damage arising from any act or
                    omission of the Customer or any other person acting on the
                    Customer’s behalf including a failure to declare or false
                    declaration of value (and so that the Customer shall
                    indemnify SG Transport accordingly); (iv) any other loss or damage
                    of whatever nature, including but not limited to any loss of
                    or damage to any internal parts of any object, unless the
                    Customer is able to prove that the same is directly
                    attributable to the negligence of SG Transport.
                    <br />
                    <br />
                    No liability for damage to Goods will be accepted by SG Transport
                    unless SG Transport has been given a reasonable opportunity to
                    inspect such damage. Claims if any, should be lodged within
                    24 hours from the <em>date of delivery</em> in writing and
                    would be entertained by either the third-party insurance
                    agent or SG Transport depending on what has been opted by the
                    Customer at the time of the booking. In the case where the
                    Customer has opted for a third-party insurance, only the
                    third-party insurance company shall be liable for such
                    claims and not SG Transport, under any circumstances.
                  </p>
                </li>

                <li className="text mb-md-3 mb-3">
                  <p>
                    The Customer undertakes that no claim shall be made against
                    any employee or agent of SG Transport which imposes or attempts to
                    impose upon them (i.e. any employee or agent of SG Transport) any
                    liability whatsoever in connection with the Services and, if
                    any such claim should nevertheless be made, to indemnify
                    SG Transport against all consequences thereof. Without prejudice
                    to the foregoing, all such employees or agents shall have
                    the benefit of all provisions herein as if such provisions
                    were expressly for their benefit.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Payment should be done prior to packing / dispatch by UPI/
                    cash/ online transfer/ other permitted means as applicable.
                    In any case if the payment is not cleared before delivery,
                    SG Transport reserves the right to withhold the delivery till the
                    complete payment is received.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    During any transit, SG Transport shall be permitted to open and
                    display any items should it be required to do so by law
                    enforcement or police authorities.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    Neither SG Transport, its affiliates, subsidiaries,
                    advertisements, marketing campaigns etc. promote any form of
                    gambling or betting.
                  </p>
                </li>
                <li className="text mb-md-3 mb-3">
                  <p>
                    The 100% Damage Free Shifting claim in SG Transport's
                    advertisements and marketing campaigns is based on 9.5
                    Lakhs+ damage-free orders carried out by SG Transport and is not
                    an indicator of any damage free transport, which SG Transport
                    endeavours to provide.
                  </p>
                </li>
              </ol>
            </div>
          </div>
        </Container>
        <div className="privacy_overlay"></div>
      </section>
    </>
  );
}

export default TermsCondition_SSI;
